import { Boxes, ListOrdered } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { AGENT_PERMISSIONS } from '@/lib/permissions'

import { entityAssetsRoute, entityUnrecognizedAssetsRoute, entityAssetDetailRoute, entityAssetNetworkRoute, entityAssetSecurityRoute, entityAssetFirewallRulesRoute, entityAssetManagementRoute, entityAssetSourceRoute, entityAssetSettingsRoute, entityAssetMetersRoute, entityAssetSuppliesRoute, entityPrintSettingsRoute } from './routes'

import { assetHomeWidgets } from './home-widgets'
import { printerEventRulePolicyKind } from './features/event-rule-policies/event-rule-policy-kind'

import { preferredCounterPolicyKind } from './features/preferred-counter-policies/preferred-counter-policy-kind'
import { entityPrinterPoliciesRoute, entityPrinterPolicyRoute } from './routes'

export const assetsModule = defineModule({
  widgets: assetHomeWidgets,
  policyKinds: [preferredCounterPolicyKind, printerEventRulePolicyKind],
  routes: [
    entityAssetsRoute,
    entityUnrecognizedAssetsRoute,
    entityAssetDetailRoute,
    entityAssetNetworkRoute,
    entityAssetSecurityRoute,
    entityAssetFirewallRulesRoute,
    entityAssetManagementRoute,
    entityAssetSourceRoute,
    entityAssetSettingsRoute,
    entityAssetMetersRoute,
    entityAssetSuppliesRoute,
    entityPrintSettingsRoute,
    entityPrinterPoliciesRoute,
    entityPrinterPolicyRoute,
  ],
  sections: {
    dataCollection: [{ id: 'assets', label: 'Assets', order: 20 }],
  },
  navigation: {
    dataCollection: [
      {
        to: '/$entityId/assets',
        label: 'Assets',
        icon: Boxes,
        permission: AGENT_PERMISSIONS.read,
        section: 'assets',
        order: 10,
      },
      {
        to: '/$entityId/assets/configuration/printer-policies',
        label: 'Printer policies',
        icon: ListOrdered,
        permission: AGENT_PERMISSIONS.read,
        section: 'assets',
        order: 30,
      },
    ],
  },
})
